// qr.service.ts
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

import { toDataURL } from 'qrcode';

@Injectable({ providedIn: 'root' })
export class QrService {
  private readonly BASE_URL =
    environment.baseUrl + '/Yoklama/AddAttendanceRecord';

  /**
   * 🔲 QR için URL üretir (JSON YOK)
   */
  buildAttendanceUrl(params: {
    token: string;
    courseStartId: number;
    courseId: number;
    teacherId: string;
    slotCount: number;
    slotNumber: number;
    haftalikDersId: number;
    acilanDersDetayNo: number;
    akademikPersonelNo: number;
    acilanDersNo: number;
    obsStatus: boolean;
    konumDisi: boolean;
    yoklamaNo: string;
  }): string {

    const query = new URLSearchParams({
      course_startId: params.courseStartId.toString(),
      courseId: params.courseId.toString(),
      teacherId: params.teacherId,
      slotCount: params.slotCount.toString(),
      slotNumber: params.slotNumber.toString(),
      haftalikDersId: params.haftalikDersId.toString(),
      acilanDersDetayNo: params.acilanDersDetayNo.toString(),
      akademikPersonelNo: params.akademikPersonelNo.toString(),
      acilanDersNo: params.acilanDersNo.toString(),
      obsStatus: params.obsStatus.toString(),
      konumDisi: params.konumDisi.toString(),
      token: params.token,
      yoklamaNo: params.yoklamaNo,
    });

    return `${this.BASE_URL}?${query.toString()}`;
  }

  /**
   * 🔥 QR IMAGE ÜRETİR (URL -> QR)
   */
  async generateAttendanceQr(params: {
    token: string;
    courseStartId: number;
    courseId: number;
    teacherId: string;
    slotCount: number;
    slotNumber: number;
    haftalikDersId: number;
    acilanDersDetayNo: number;
    akademikPersonelNo: number;
    acilanDersNo: number;
    obsStatus: boolean;
    konumDisi: boolean;
    yoklamaNo: string;
  }): Promise<string> {
    const url = this.buildAttendanceUrl(params);

    return toDataURL(url, {
      width: 1024,
      margin: 1,
      errorCorrectionLevel: 'M',
    });
  }
}
